import setLanguage from "next-translate/setLanguage";
import React from "react";

const button =
  "outline-0 border-none bg-transparent text-white hover:text-green-400 cursor-pointer";

const Flag = () => (
  <div className="df aic">
    <button
      onClick={() => {
        setLanguage("en", false);
      }}
      className={button}
    >
      English
    </button>
    <span className="ml2 mr2 text-white">|</span>
    <button
      onClick={() => {
        setLanguage("es", false);
      }}
      className={button}
    >
      Español(Beta)
    </button>
    <span className="ml2 mr2 text-white">|</span>
    <button
      onClick={() => {
        setLanguage("zh", false);
      }}
      className={button}
    >
      中文(Beta)
    </button>
  </div>
);

export default React.memo(Flag);
